import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { Section, Eyebrow, Reveal } from "./shared";
import { FAQ as FAQ_DATA } from "../../lib/site";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <Section id="faq" bg="bg-white">
      <Reveal className="max-w-3xl">
        <Eyebrow color="#0B31EB">FAQ</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.98] mt-5">Questions, Answered.</h2>
      </Reveal>

      <div className="mt-12 max-w-4xl space-y-3">
        {FAQ_DATA.map((f, i) => {
          const active = open === i;
          return (
            <Reveal key={f.q} delay={(i % 5) * 0.03}>
              <div className={`rounded-[18px] border-2 border-brand-black overflow-hidden ${active ? "bg-brand-cream shadow-[6px_8px_0_#0B31EB]" : "bg-white"}`}>
                <button onClick={() => setOpen(active ? -1 : i)} data-testid={`faq-toggle-${i}`} aria-expanded={active}
                  className="w-full flex items-center justify-between gap-3 p-5 text-left">
                  <span className="font-semibold text-base sm:text-lg">{f.q}</span>
                  <span className="h-8 w-8 rounded-full border-2 border-brand-black flex items-center justify-center shrink-0 bg-white">
                    {active ? <Minus size={15} /> : <Plus size={15} />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {active && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm sm:text-base text-brand-ink/75 leading-relaxed">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
}
